import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/jobs")({
  head: () => buildRouteHead("/en/jobs", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/en/about-qbd", replace: true });
  },
});
